import React,{useState,useEffect} from "react";
import axios from "axios";
import "../assets/css/DateRange.css"
import {
    Box,
    Grid,
    Typography,
    TextField,
    Button,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip
  } from "@mui/material";
  import {
    RadioGroup,
    FormControlLabel,
    Radio,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Card,
    CardContent,
    IconButton,
  } from "@mui/material";
  import dayjs from 'dayjs';
import { GoDot } from "react-icons/go";
import { IoMdSearch } from "react-icons/io";
import { StyledEngineProvider } from '@mui/material/styles';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FiInfo } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import Modal from "@mui/material/Modal";
import { PickersDay } from '@mui/x-date-pickers/PickersDay'
const RenderCurationHistory=()=>{
    const [CurationName, setCurationName] = useState(null);
    const [CurationDate,SetCurationDate]=useState(null);
    const [sources, setSources] = useState([]);
    const [Record, setRecord] = useState([]);
    const [value, setValue] = React.useState(new Date());
    const [openModel, setOpenModel] = React.useState(false);
    const [Command,setCommand]=useState();
    const [isDatePickerDisabled, setIsDatePickerDisabled] = useState(true);
    const [enabledDate, setEnabledDates] = useState([]);

    useEffect(() => {
      // Scroll to the top of the page on component mount
      window.scrollTo(0, 0);
    }, []); // Empty dependency array to only run on component mount
    useEffect(() => {
        fetchSources();
      }, []);
      useEffect(() => {
        if (CurationName) {
          fetchCurationDates();
          setRecord([]);
        } else {
          SetCurationDate(null); // Reset the selected date if no CurationName is selected
          setEnabledDates([]); // Clear available dates
          setIsDatePickerDisabled(true); // Disable DatePicker when CurationName is not selected
        }
      }, [CurationName]);
      useEffect(() => {
        if (CurationDate) {
          fetchCurationDetailsHistory();
        }
        console.log(CurationName, CurationDate);
      }, [CurationDate]);
      const showToast = () => {
        toast.error("No records found", {
          duration: 2000,
          position: "top-right",
        });
      };
      function formatDate(date, type) {
        // Regex pattern to validate format dd-mm-yyyy hh:mm:ss
        const datePattern = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
        
        // Check if the input matches the expected format
        if (!datePattern.test(date)) {
            return date; // Return the input unchanged if the format is invalid
        }
    
        const dateVal = new Date(date);
    
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    
        // Split the date and time
        const [datePart, timePart] = date.split(' ');
    
        // Split the date part into day, month, year
        const [day, month, year] = datePart.split('-');
    
        // Split the time part into hours, minutes, and seconds
        const [hours, minutes] = timePart.split(':');
    
        // Convert the month number to a 3-letter abbreviation
        const monthAbbr = months[parseInt(month, 10) - 1];
    
        // UTC time (for reference)
        const utcYear = dateVal.getUTCFullYear();
        const utcMonth = String(dateVal.getUTCMonth() + 1).padStart(2, '0');
        const utcDay = String(dateVal.getUTCDate()).padStart(2, '0');
        const utcHours = String(dateVal.getUTCHours()).padStart(2, '0');
        const utcMinutes = String(dateVal.getUTCMinutes()).padStart(2, '0');
    
        const utcMonthName = dateVal.toLocaleString('default', { month: 'long', timeZone: 'UTC' }).slice(0, 3).toUpperCase();
    
        if (type === 'textfield') {
            // Return ISO format for textfield input
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }else if(type === "date"){
          return `${day}-${month}-${year}`;
        } else {
            // Return formatted date with month abbreviation
            return `${day}-${month}-${year} ${hours}:${minutes}`;
        }
    }
    const fetchCurationDates = async () => {
      try {
        const apiUrl = `get-curation-dates/?curation_name=${CurationName}`;
            const response = await axios.get(apiUrl);
        // const apiUrl = `get-curation-details-history/?curation_name=${CurationName}`;
        // const response = await axios.get(apiUrl,CurationName);
        console.log('API Response:', response.data); // Log the API response
    
        // Extract distinct_curation_dates from the response directly
        const fetchedDates = response.data?.distinct_curation_dates || [];
        
        // Log fetched dates
        console.log('Fetched Dates:', fetchedDates); 
    
        if (fetchedDates.length > 0) {
          setEnabledDates(fetchedDates);
          setIsDatePickerDisabled(false); // Enable DatePicker
        } else {
          setIsDatePickerDisabled(true); // Disable DatePicker if no dates
        }
      } catch (error) {
        console.error("Error fetching sources:", error);
        setIsDatePickerDisabled(true); // Disable DatePicker on error
      }
    };
    
    // const fetchCurationDates = async () => {
    //   try {
        
    //     const apiUrl = `get-curation-dates/?curation_name=${CurationName}`;
    //     const response = await axios.get(apiUrl);
    //     const data = response?.data || [];
    //     console.log(data,"response");
        
  
    //     // Assuming the response contains dates to enable
    //     const fetchedDates = data?.map(item => item.distinct_curation_dates) || [];
    //     // Adjust according to your API response
    //     setEnabledDates(fetchedDates);
    // console.log(fetchedDates,"dates");
    
    //     if (fetchedDates.length > 0) {
    //       setIsDatePickerDisabled(false); // Enable DatePicker after fetching dates
    //     }
    //   } catch (error) {
    //     console.error("Error fetching sources:", error);
    //     setIsDatePickerDisabled(true); // Disable DatePicker on error
    //   }
    // };
      const fetchCurationDetailsHistory = async () => {
        try {
            const apiUrl = `get-curation-details-history/?curation_name=${CurationName}&curation_date=${CurationDate}`;
            const response = await axios.get(apiUrl);
            console.log(response,"res")
            setRecord(() => {
              const data = response?.data || [];
      
              if (data.length < 2) {
                 
                  return data; 
              }
      
              if (!data[0]?.previous_run) {
                  return [data[1], data[0]];
              }
      
              return data;
          });
            // console.log(response.data);
        } catch (error) {
          console.error("Error fetching sources:", error);
          showToast()
          setRecord([])
        }
      };
      const fetchSources = async () => {
        try {
          const apiUrl = `/get-distinct-curation-names-drp/`;
          const response = await axios.get(apiUrl);
          setSources(response.data);
        } catch (error) {
          console.error("Error fetching sources:", error);
        }
      };
      const handleClose = () => {
        setOpenModel(false);
      };
      const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        borderRadius: "7px",
        boxShadow: 24,
       
      };
      const fieldMappings = [
        { label: "Curation Name", key: "curation_name", editable: false },
        {
          label: "Frequency",
          key: "frequency",
        },
        {
          label: "No of Files (Expected/Arrived)",
          key: "no_of_files",
          editable: true,
        },
        {
          label: "Arrival Datetime",
          key: "arrival_datetime",
          editable: true,
          type: "datetime",
        },
        {
          label: "Load Datetime",
          key: "load_datetime",
          editable: true,
          type: "datetime",
        },
        {
          label: "Curation Date",
          key: "curation_date",
          editable: true,
          // type: "datetime",
        },
        {
          label: "Curation Start Time",
          key: "curation_start_time",
          editable: true,
          type: "time",
        },
        {
          label: "Curation End Time",
          key: "curation_end_time",
          editable: true,
          type: "time",
        },
        { label: "Time Taken", key: "time_taken",type:'time' },
        {
          label: "Last Load Date",
          key: "last_load_datetime",
          editable: true,
          type: "date",
        },
        {
          label: "Last Curation Date",
          key: "last_curation_datetime",
          editable: true,
          type: "date",
        },
        // {
        //   label: "Dashboards Connected",
        //   key: "dashboards_connected",
        // },
        // {
        //   label: "Snowflake Validation Status",
        //   key: "snowflake_validation_status",
        //   editable: true,
        // },
        // {
        //   label: "Snowflake Validated By",
        //   key: "snowflake_validated_by",
        //   editable: true,
        // },
        {
          label: "AceDO Validation Status",
          key: "acedo_validation_status",
          editable: true,
        },
        // {
        //   label: "Descriptie Analysis Insights",
        //   key: "Descriptive_Analysis_Insights",
        //   editable: true,
        // },
        { label: "Validated by", key: "validated_by"},
        { label: "Created at", key: "created_at", editable: false,type:"datetime" },
        { label: "Refreshed by", key: "refreshed_by"},
      ];
      const handleOpen = (str) => {
        setCommand(str);
        setOpenModel(true);
      };
      // const enabledDates = ['2024-10-10', '2024-10-15', '2024-10-20'];
   
      
   

      function isDateDisabled(date) {
        // Enable only the dates present in the array of enabled dates
        return !enabledDate.includes(dayjs(date).format('YYYY-MM-DD'));
      }
      
  const handleCurationChange = (e) => {
    setCurationName(e.target.value);
    setEnabledDates([]); // Clear previously enabled dates
    SetCurationDate(null); // Reset selected date
  };
  const timeString = (val) => {
    if (!val) {
      return "-";  // Return a default message or value if val is null or undefined
    }
  
    // const [hours, minutes] = val.split(":");  // Safely split the time string
    return `${val} mins`;
  };
  
    return(
        <>
          <div id="frequency_selector" style={{marginTop:"1rem"}}>
         
          <div>
            <Card sx={{boxShadow:"none",borderRadius:"12px"}}>
            <div
            style={{ display:"flex",alignItems:"flex-end", justifyContent:"space-between"}}
          > 
           <div
           style={{
            paddingBottom:"10px"
           }}>
           {(CurationName && CurationDate) && (
                <Typography sx={{ textAlign: "center", fontWeight: "550",marginLeft:"1rem" }}>
                  {CurationName}
                </Typography>
              ) }
           </div>
              <div style={{display:"flex",alignItems:"flex-end",}}>
              <FormControl>
            <Select
              value={CurationName || "" }
              size="small"
              onChange={handleCurationChange}
              className="mx-4 h-25"
              displayEmpty
            >
               <MenuItem value="">Select Curation</MenuItem>
              {
              sources?.map( (item)=>(
                <MenuItem value={item!=="" && item}>{item!=="" && item.replaceAll('_'," ")}</MenuItem>
              ))
            }
            </Select>
          </FormControl>
          <StyledEngineProvider injectFirst>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                <DatePicker
                className="daterange"
                size="small"
                renderInput={(params) => <TextField {...params} />}
                value={CurationDate ? dayjs(CurationDate) : null} 
                // Ensure value is a dayjs object
                
                onChange={(newValue) => {
                  if (newValue && dayjs(newValue).isValid()) {  // Check if the value is valid
                    const formattedDate = newValue.format('YYYY-MM-DD');
                    SetCurationDate(formattedDate);
                  } else {
                    console.log('Invalid date selected');
                  }
                }}
                shouldDisableDate={isDateDisabled} 
                disabled={isDatePickerDisabled}
                slotProps={{ textField: { size: 'small' } }}
                renderDay={(day, selectedDates, pickersDayProps) => {
                  const isDisabled = isDateDisabled(day);
                
    
                  return (
                    <div
                      style={{
                        padding: '10px',
                        backgroundColor: isDisabled ? 'lightgray' : "red",
                        borderRadius: '50%',
                        color: isDisabled ? 'gray' : 'black',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        transition: 'background-color 0.2s',
                      }}
                      {...pickersDayProps}
                    >
                      {day.date()}
                    </div>
                  );
                }}
              />

                </DemoContainer>
              </LocalizationProvider>
          </StyledEngineProvider>
              </div>
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
          <div
            style={{
              display: "flex",
              overflowX: "hidden",
              alignItems: "stretch",
              // boxShadow:
              //   "rgba(149, 157, 165, 0.1) 0px 3px 6px 0px, rgba(149, 157, 165, 0.1) 0px -4px 6px 0px",
              marginLeft:"0.3rem",
              marginRight:"0.3rem",
              // marginTop:"0.5rem",
             
              paddingRight:"1%",
              // paddingBottom:"1%",
              width:"100%",
              // borderRadius:"10px",
            }}
          >
            <div
              style={{
                flex: "0 0 auto",
                minWidth: "20%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Card
                sx={{
                  height: "100%",
                  boxShadow: "none",
                  borderRadius: "12px",
                 
                }}
              >
                <div
                  style={{
                    color: "#000",
                    backgroundColor: "#fff",
                    padding: "15px 0px",
                    marginLeft:"1.4rem",
                    fontWeight: "bold",
                    borderBottom:"1px solid #eaeaea",
                    
                    // width:"70%",
                  }}
                >
                  Run Status 
                </div>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "8px 0px",
                    backgroundColor:"#fff",
                    margin:"0.5rem"
                  }}
                >
                  {fieldMappings?.map(
                    (field, fieldIndex) =>
                      fieldIndex > 0 && (
                        <Box key={fieldIndex} sx={{ marginBottom:"0.6rem"}}>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            <GoDot
                              style={{ marginRight: "0.6rem", color: "#6a6b6d" }}
                              />
                            {field.label}
                          </Typography>
                        </Box>
                      )
                  )}

                </CardContent>
              </Card>
            </div>

            <div

              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: Record.length === 0 ? "center" : "",
                alignItems: Record.length === 0 ? "center" : "",
                flexWrap: "nowrap",
                overflowX: "hidden",
                flex: "1 1 auto",
                borderRadius: "0px 5px 5px 0px",
                backgroundColor: "#fff",
                padding: "0px 6px",
                position: "relative",

                // maxWidth:
                // cardsToShow === 4 ? "66rem" : cardsToShow === 3 ? "49rem" : cardsToShow === 2 ? "33rem" : "17rem",
              }}
            >
          

              { Record.length === 0 ? (
                <>
                  <span
                    style={{
                      width: "100rem",
                      height: "30%",
                      color: "#707070",
                      textAlign: "center",
                      margin:"0 20rem",
                      // backgroundColor:"purple",
                      padding:"0 30px"
                    }}
                  >
                    <div style={{ fontSize: "80px" }}>
                      <IoMdSearch />
                    </div>
                    <Typography
                      sx={{  bottom: "45px", width: "40rem" }}
                    >
                      Please Select the Curation Name{" "}
                    </Typography>
                  </span>
                </>
              ) :  (
                Record
                  .map((record, index) => (
                    <div
                      key={index}
                      style={{
                        flex: "0 0 auto",
                        width: "16.4rem",
                        marginRight: "1rem",
                        display: "flex",
                        flexDirection: "column",
                        marginX: "0.3rem",
                        marginLeft: "1rem",
                        paddingBottom:"7px",
                        paddingTop:"10px",
                      }}
                    >
                      
                      <Card
                        sx={{
                          position: "relative",
                          // height: "100%",
                          paddingBottom:"16px",
                          cursor: "pointer",
                          // borderRadius: "12px",
                          transition: ".2s",
                          backgroundColor: "#EBF4FF",
                          padding: "10px",
                          ":hover": {
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                            transform: "scale(1.02)",
                          },
                        }}
                      >
          
                              <div
                                style={{
                                  color: "#000",
                                  fontWeight: "bold",
                                  padding: "0px 7px 11px 7px",
                                  // textAlign: EditId !== record.id ? "center" : "left",
                                  textAlign: "left",
                                  backgroundColor: "transparent",
                                  fontSize:"14px"
                                }}
                              >
                                <div
                                  className="text-truncate"
                                  style={{ width: "76%" }}
                                >
                                  {" "}
                                  {/* <Tooltip title={record["curation_name"]}>{record["curation_name"]}</Tooltip>  */}
                                  {record["previous_run"]===true ? "PREVIOUS" : "CURRENT"}
                                </div>
                              </div>
                      
                        <CardContent
                          sx={{
                            height: "93%",
                            padding:0,
                            paddingLeft:"16px",
                            paddingTop: "2px",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                          }}
                        >
                          {fieldMappings.map((field, fieldIndex) => (
                            <Box
                              key={fieldIndex}
                              sx={{
                                marginBottom: "0.52rem" ,
                              }}
                            >
                           
                           { 
                              field.key === "no_of_files" ? (
                                <>
                                  <span
                                    style={{
                                      backgroundColor: "#fdca02",
                                      padding: "2px 4px",
                                      borderRadius: "7px",
                                      color: "#000",
                                    }}
                                  > 
                                    Expected: 
                                    <strong>
                                      {Number(record.no_of_files?.Expected) || "-"}
                                    </strong>
                                  </span>{" | "}
                                  <span
                                    style={{
                                      backgroundColor: Number(record.no_of_files?.Arrived) < Number(record.no_of_files?.Expected) ? "#e5453d" : "#1e8fff",
                                      padding: "2px 4px",
                                      borderRadius: "7px",
                                      color: "#fff",
                                    }}
                                  > 
                                    Arrived: 
                                    <strong>
                                    <span
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      {Number(record.no_of_files?.Arrived) || "-"}
                                    </span>
                                   
                                    </strong>
                                  </span>
                                </>
                              ) :
                              <Typography
                              sx={{ fontSize: "14px", color: "#333",marginTop:"0.7rem" }}
                            >
                              { (field.key!=="curation_name" &&
                                 ( field.type==='datetime' && field.key!=="created_at" &&  field.key !== "curation_date" ?
                                (record[field.key]!==null &&  formatDate(record[field.key])|| "-")
                                :
                                field.type ==="time" ? timeString(record[field.key])
                                :
                                field.type ==="date" ? formatDate(record[field.key],"date")||"-"
                                :
                                field.key === "time_taken" ?
                                `${record[field.key].split(":")[0]} hrs ${record[field.key].split(":")[1]} mins`
                                :
                                field.key === "frequency" ?
                                <div className="d-flex" style={{justifyContent:'space-between'}}>
                                <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "#333",
                                  padding: "2px 4px 2px 4px",
                                  borderRadius: "7px",
                                }}>
                                 { record[field.key].charAt(0).toUpperCase() + record[field.key].slice(1).toLowerCase()}
                                 </Typography>
                                 {(record['refreshed_status'] =="YES") &&
                          <div  className="me-2" style={{ color:'#00cc99',padding:'2px 5px',borderRadius:'5px',fontWeight:'650',fontSize:'0.775rem'}}>
                          <TaskAltIcon />
                          <label className="ms-1">REFRESHED</label>
                          </div>} 
                          </div>
                               
                                :
                                field.key === "curation_date" ?
                                <Typography
                                sx={{
                                   fontWeight: "bold",
                                  fontSize: "14px",
                                  // color: "#333",
                                  // padding: "2px 4px 2px 4px",
                                  // borderRadius: "7px",
                                  // textAlign:"center",
                                  // marginTop:"1.2rem",
                                  // bgcolor:"#f28304"
                                }}>
                                  {record[field.key] || "-"}
                                </Typography>
                                :
                                field.key === "created_at"  ? 
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      // color: "#333",
                                      // bgcolor: "#3798b8",
                                      // padding: "2px 4px 2px 4px",
                                      // borderRadius: "7px",
                                      // textAlign:"center",
                                    }}
                                  >
                                    {record[field.key]!==null && formatDate(record[field.key]) }
                                  </Typography>
                                    :
                                    field.key === "validated_by" ?
                                    <Typography
                                    sx={{
                                      fontWeight:"bold",
                                      fontSize: "14px",
                                      // color: "#333",
                                      // padding: "2px 4px 2px 4px",
                                      // borderRadius: "7px",
                                      // textAlign:"center",
                                      // bgcolor:"#f28304"
                                    }}>
                                    { record[field.key]}
                                    </Typography>
                                    :
                                    field.key === "refreshed_by" ?
                                     <Typography
                                     sx={{
                                       fontWeight: "bold",
                                       fontSize: "14px",
                                       // color: "#333",
                                       // padding: "2px 4px 2px 4px",
                                       // borderRadius: "7px",
                                       // textAlign:"center",
                                       // marginTop:"1.2rem",
                                       // bgcolor:"#f28304"
                                     }}>
                                      { record[field.key] || "-"}
                                     </Typography>
                                  :
                                  field.key==="acedo_validation_status" ?
                                  <div style={{color:record[field.key]=='no'? 'red' : '#333'}}>
                                  {  record[field.key]?.toUpperCase()}
                                </div>
                                  : 
                                  ((field.key !== "validated_by" && field.key !== "curation_datetime") && (record[field.key]  || "-")))
                              )}
                            </Typography>
                            }     
                            </Box>
                          ))}
                      
                         
                        </CardContent>
                       
                        <div style={{ position: "absolute", top: 7.5, right: 10 }}>
                        <Tooltip title={ "Show Descriptive Analysis Insights"}>
                          <IconButton
                            size="small"
                            color={"error"}
                            onClick={() => { handleOpen(record?.['Descriptive_Analysis_Insights']);
                            }}
                          >
                            { <FiInfo />}
                          </IconButton></Tooltip>
                        </div>
                      </Card>
                    </div>
                  ))
              )} 
         
            </div>
            </div>
            </div>
      </Card>
          </div>
        </div>
        <Modal open={openModel} onClose={handleClose}>
      <Box sx={{ ...style, width: 400 }}>
        <div style={{display:"flex",justifyContent:"center"}}>
            <Typography
              id="modal-modal-title"
              variant="h6"
             
              sx={{padding:"30px 20px 0px 40px"}}
              component="h2"
            >
             Descriptive Analysis Insights
            </Typography>
           </div>
           <p id="child-modal-description" style={{padding:"20px",textAlign:"justify"}}>{Command}</p>
        </Box>
      </Modal>
        <ToastContainer
        toastOptions={{
          style: {
            fontSize: "20px",
            padding: "16px",
            width: "350px",
          },
        }}
      />
        </>
    )
}
export default RenderCurationHistory